import scrollManager from '../utils/scroll-manager';
import { SlimSelectHTMLElement } from '../utils/slim-select';

export default function initLogosRequestForm() {
    const $form = document.querySelector<HTMLFormElement>('.js-logos-request-form');

    if ($form) {
        new LogosRequestForm($form);
    }
}

class LogosRequestForm {
    $form: HTMLFormElement;
    $stepOneContainer: HTMLDivElement;
    $stepTwoContainer: HTMLDivElement;
    $logosInput: NodeListOf<HTMLInputElement>;
    $stepOneSubmitButton: HTMLButtonElement;
    $activityTypeSelect: SlimSelectHTMLElement;
    $productionSiteAddButton: HTMLButtonElement;
    $productionSitesHolder: HTMLDivElement;

    constructor($form: HTMLFormElement) {
        this.$form = $form;
        this.$stepOneContainer = this.$form.querySelector('[data-logos-request-form-step-one]') as HTMLDivElement;
        this.$stepTwoContainer = this.$form.querySelector('[data-logos-request-form-step-two]') as HTMLDivElement;
        this.$logosInput = this.$form.querySelectorAll<HTMLInputElement>('[data-logos-request-form-logo-input]');
        this.$stepOneSubmitButton = this.$form.querySelector('[data-logos-request-form-step-one-submit-button]') as HTMLButtonElement;
        this.$activityTypeSelect = this.$form.querySelector('[data-logos-request-form-activity-type-select]') as SlimSelectHTMLElement;
        this.$productionSiteAddButton = this.$form.querySelector('.js-logos-request-form-add-production-site-button') as HTMLButtonElement;
        this.$productionSitesHolder = this.$form.querySelector('.js-logos-request-form-production-sites-holder') as HTMLDivElement;

        // Active le bouton pour passer à l'étape 2 si au moins 1 logo a été sélectionné
        this.checkForEnablingStepOneSubmitButton();
        this.$logosInput.forEach($input => {
            $input.addEventListener('change', () => {
                this.checkForEnablingStepOneSubmitButton();
                $input.closest('.request-logo-label')?.classList.toggle('request-logo-label--active' , $input.checked);
            });
        });

        // Affiche l'étape 2 du formulaire au clique sur le bouton de soumission de l'étape 1
        this.$stepOneSubmitButton.addEventListener('click', this.goToStepTwo.bind(this));

        // Affiche les éléments du formulaire correspondant au type de bénéficiaire sélectionné
        this.showElementsAccordingActivityTypeSelectContent();
        this.$activityTypeSelect.slim.onChange = () => {
            this.showElementsAccordingActivityTypeSelectContent();
        };

        // Suppression d'un site de production au clique sur le bouton
        this.$form.querySelectorAll<HTMLButtonElement>('.js-logos-request-form-remove-production-site-button').forEach($removeBtn => {
            $removeBtn.addEventListener('click', () => {
                $removeBtn.closest('.js-production-site')?.remove();
            });
        });

        // Ajout d'un site de production au clique sur le bouton
        this.$productionSiteAddButton.addEventListener('click', () => {
            // Création de la div qui contiendra les champs
            const $item = document.createElement('div');
            $item.classList.add('flex-child', 'production-site', 'js-production-site');

            // Ajout du prototype dans la div
            const prototype = this.$productionSitesHolder.dataset.prototype as string;
            const index = this.$productionSitesHolder.dataset.index as string;
            $item.innerHTML = prototype.replace(/__name__/g, index);

            // Ajout du bouton de suppression dans la div
            const $removeButton = $item.querySelector('.js-logos-request-form-remove-production-site-button') as HTMLButtonElement;

            // Ajout de la div dans la page
            this.$productionSitesHolder.appendChild($item);
            this.$productionSitesHolder.dataset.index = '' + (parseInt(index) + 1);

            // Suppression de la div au clique sur le bouton de suppression
            $removeButton.addEventListener('click', () => {
                $item.remove();
            });
        });
    }

    /**
     * Active le bouton pour passer à l'étape 2 si au moins 1 logo a été sélectionné
     * 
     * @return {void}
     */
    checkForEnablingStepOneSubmitButton() : void {
        const nbOfSelectedLogos = Array.from(this.$logosInput).filter($input => $input.checked).length;

        if (nbOfSelectedLogos > 0) {
            this.$stepOneSubmitButton.removeAttribute('disabled');
        } else {
            this.$stepOneSubmitButton.setAttribute('disabled', '');
        }
    }

    /**
     * Affiche l'étape 2 du formulaire
     * 
     * @return {void}
     */
    goToStepTwo() : void {
        this.$stepOneContainer.classList.add('step-one--check');
        this.$stepTwoContainer.classList.add('step-two--active');

        // Scroll en haut du formulaire si on se trouve trop bas
        const adminBarHeight = parseInt(getComputedStyle(document.body).getPropertyValue('--admin-bar-height'));
        const headerHeight = parseInt(getComputedStyle(document.body).getPropertyValue('--header-height'));
        const scrollOffset = adminBarHeight + headerHeight + 50;
        scrollManager.scrollTo(this.$form, true, scrollOffset, 'down');
    }

    /**
     * Affiche les éléments du formulaire correspondant au type de bénéficiaire sélectionné
     * 
     * @return {void}
     */
    showElementsAccordingActivityTypeSelectContent() : void {
        const activityType = this.$activityTypeSelect.slim.selected();
        if (typeof activityType !== 'undefined') {
            this.$form.querySelectorAll<HTMLElement>('[data-show-if-activity-type]').forEach($element => {
                $element.classList.toggle('hidden-activity-field', $element.dataset.showIfActivityType !== activityType);
            });
        }
    }
}
